import { HelpIcon } from './HelpIcon';

export function DateField({ id, label, value, onChange, error, helpText, required, readOnly, min, type = 'date' }) {
  return (
    <div className="fw">
      <label className="fl" htmlFor={`field-${id}`}>
        {label}
        {required && <span className="req"> *</span>}
        {helpText && <HelpIcon text={helpText} id={id} />}
      </label>
      <input id={`field-${id}`} type={type} value={value ?? ''} onChange={e => onChange(e.target.value)}
        readOnly={readOnly} min={min} aria-invalid={!!error}
        className={`field-input${error ? ' field-error-border' : ''}${readOnly ? ' field-readonly' : ''}`} />
      {error && <span className="ferr" role="alert">{error}</span>}
    </div>
  );
}
